// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KGir","largestCol":"styles_largestCol__19oX-","smallestCol":"styles_smallestCol__2W3YS"};